import React from "react";
import SvgSelector from "../svgSelector/SvgSelector";
import "./CampaignStatistic.css"

interface CampaignStatisticProps {
    all:number,
    live:number,
    pause:number,
    end:number,
    draft: number,
    scheduled: number
}
 
interface CampaignStatisticState {
    
}
 
class CampaignStatistic extends React.Component<CampaignStatisticProps, CampaignStatisticState> {

    constructor(props: CampaignStatisticProps) {
        super(props);
    }
    
    render() { 
        return (
            <div className="campaign-info">
                <div className="campaign-info__block">
                    <div className="campaign-info__elem all">
                        <SvgSelector title="campaign-all" />
                        <p> <b>{this.props.all}</b> Campaign Total </p>
                    </div>
                    <div className="campaign-info__elem live">
                        <SvgSelector title="campaign-live" />
                        <p> <b>{this.props.live}</b>Campaign Live </p>
                    </div>
                </div>
                <div className="campaign-info__block">
                    <div className="campaign-info__elem all">
                        {/* <SvgSelector title="campaign-all" /> */}
                        <p> <b>{this.props.draft}</b> Campaign Draft </p>
                    </div>
                    <div className="campaign-info__elem live">
                        {/* <SvgSelector title="campaign-live" /> */}
                        <p> <b>{this.props.scheduled}</b>Campaign Scheduled </p>
                    </div>
                </div>
                <div className="campaign-info__block">
                    <div className="campaign-info__elem pause">
                        <SvgSelector title="campaign-pause" />
                        <p> <b>{this.props.pause}</b>Campaign Paused </p>
                    </div>
                    <div className="campaign-info__elem end">
                        <SvgSelector title="campaign-end" />
                        <p> <b>{this.props.end}</b> Campaign Expired </p>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default CampaignStatistic;